import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { routes } from '../../../../../constants';
import { Icon } from '../../../../components';

class PendingTasksIcon extends Component {
  render() {
    const { tasks } = this.props
    const pendingCount = tasks.length

    return <LinkContainer className='flex-center' to={routes.app.tasks.home}>
      <div id='pending-tasks-icon'>
        <div className='pending-tasks-counter flex-center'>{pendingCount}</div>
        <Icon icon='training-large' />
      </div>
    </LinkContainer>
  }
}

export default PendingTasksIcon;



// WEBPACK FOOTER //
// ./src/containers/pages/app/dashboard/partials/pending-tasks-icon.js